import React, { Component } from 'react';
import flow from 'lodash/flow';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import * as Auth from 'auth/components';

import { updateInfo } from 'auth/actions';
import { addSingleInlineMessage, clearInlineMessages } from 'messages/actions';

class UpdateInfoContainer extends Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    clearInlineMessages: PropTypes.func.isRequired,
    addSingleInlineMessage: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isLoading: false,
  };

  constructor(props) {
    super(props);
    const user = JSON.parse(window.localStorage.getItem('auth.user'));
    this.state = {
      isSubmitted: false,
      isValid: false,
      values: { name: user.name, lastname: user.lastname, password: '' },
    };
  }

  componentWillMount = () => {
    this.props.clearInlineMessages();
    this.setState({
      values: {
        ...this.state.values,
        token: qs.parse(this.props.location.search).token,
      },
    });
  };

  handleSubmit = (e) => {
    this.setState(
      { isSubmitted: true },
      () =>
        this.state.isValid &&
        this.props
          .updateInfo(this.state.values)
          .then((result) => {
            this.props.history.push('/');
            this.props.addSingleInlineMessage(result.value.message, 'success');
          })
          .catch((err) => this.props.addSingleInlineMessage(err.message, 'danger'))
    );
  };

  handleValidation = (isValid, message) => {
    this.setState({ isValid }, () => {
      this.props.clearInlineMessages();
      if (!this.state.isValid && this.state.isSubmitted) {
        this.props.addSingleInlineMessage(message, 'danger');
      }
    });
  };

  handleValueChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ values: { ...this.state.values, [name]: value } });
  };

  render = () => {
    return (
      <Auth.UpdateInfoView
        handleSubmit={this.handleSubmit}
        handleValidation={this.handleValidation}
        handleValueChange={this.handleValueChange}
        isLoading={this.props.isLoading}
        isSubmitted={this.state.isSubmitted}
        values={this.state.values}
      />
    );
  };
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  updateInfo: updateInfo,
  clearInlineMessages,
  addSingleInlineMessage,
};

export default flow(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  withRouter
)(UpdateInfoContainer);



// WEBPACK FOOTER //
// src/modules/auth/containers/UpdateInfoContainer.js